var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnyIssues = function SvgAnyIssues(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M12.5 12.8h-1.8v-1.714h1.8zm1.863-6.642-.81.788c-.648.626-1.053 1.14-1.053 2.426h-1.8v-.428c0-.943.405-1.8 1.053-2.426l1.116-1.08c.333-.309.531-.737.531-1.209 0-.942-.81-1.714-1.8-1.714s-1.8.772-1.8 1.714H8C8 2.335 9.611.801 11.6.801s3.6 1.534 3.6 3.428c0 .755-.324 1.44-.837 1.929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    fillRule: "evenodd",
    d: "M7.2 4.8H4c-.88 0-1.592.72-1.592 1.6l-.006 13.17L2.4 22.4l2.001-2 2.8-2.8H20c.88 0 1.6-.72 1.6-1.6V6.4c0-.88-.72-1.6-1.6-1.6h-3.2v2h2.8v8.8H6.371l-.586.587-1.383 1.383.005-10.77H7.2z",
    clipRule: "evenodd"
  })));
};
export default SvgAnyIssues;